export const SUPERADMIN_MAIL = 'destek@aplancloud.com';
